const getIsLicensingEnabled = state => Boolean(state.registration.isLicensingEnabled);

const getIsRegistered = state => Boolean(state.registration.isRegistered);
const getIsReadOnlyMode = state => Boolean(state.registration.isReadOnlyMode);
const getIsTrialStarted = state => Boolean(state.registration.isTrialStarted);
const getIsTrialExpired = state => Boolean(state.registration.isTrialExpired);
const getExpiryDate = state => state.registration.expiryDate;
const getUpdatesHaveExpired = state => {
  const expiryDate = new Date(state.registration.expiryDate);
  const todayDate = new Date();
  return getIsRegistered(state) && todayDate > expiryDate;
};

export default {
  getIsLicensingEnabled,
  getIsRegistered,
  getIsReadOnlyMode,
  getIsTrialStarted,
  getIsTrialExpired,
  getExpiryDate,
  getUpdatesHaveExpired
};
